module.exports = __webpack_public_path__ + "static/media/polygon.1087d3d6.svg";